import { ca } from '@cian/analytics';

export function trackRulerClick(objectType?: string) {
  ca('eventSite', {
    action: 'click_show_sopr',
    category: 'Infrastructure',
    label: 'ruler',
    name: 'oldevent',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: {
        object_type: objectType,
      },
    },
    useLastProducts: true,
  });
}
